import React from 'react';

export const PulsePanel = ({ icon: Icon, title, subtitle, pill, testid, className = '', children }) => (
  <section className={`pulse-panel ${className}`} data-testid={testid}>
    <div className="pulse-panel-head">
      <Icon size={30} strokeWidth={2.2} />
      <h2 className="text-[27px] font-bold tracking-tight">{title}{subtitle && <span className="font-medium text-[22px] ml-2 opacity-90">{subtitle}</span>}</h2>
      <div className="flex-1" />
      {pill && <span className="pulse-pill">{pill}</span>}
    </div>
    <div className="flex-1 min-h-0 flex flex-col">{children}</div>
  </section>
);

export const PulseEmpty = ({ text, testid }) => (
  <div className="flex-1 flex items-center justify-center text-[20px] text-[#8a7f8f] font-medium" data-testid={testid}>{text}</div>
);
